var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1771513129830,
    className: "icon",
    viewBox: "0 0 1047 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 17849,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130.875,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640.177 73.143l62.694 129.567c16.718 37.617 54.335 62.694 96.13 68.963l140.017 20.898c104.49 14.629 144.196 142.107 71.053 217.34l-102.4 98.22c-29.257 29.257-43.886 71.053-37.616 110.759l22.988 140.016c16.718 104.49-89.862 181.812-183.903 133.747L583.753 927.87c-37.617-18.808-79.413-18.808-117.029 0l-127.477 66.874c-94.041 48.065-200.62-29.257-183.902-133.747l22.987-140.016c8.36-41.796-6.27-83.592-37.616-110.76l-102.4-100.31c-75.233-75.232-33.437-200.62 71.053-217.339l140.016-20.898c41.796-6.269 77.323-31.346 96.131-68.963L408.21 73.143c52.245-94.041 183.902-94.041 231.967 0",
    fill: "#FED44A",
    "p-id": 17850
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.39 73.143L349.695 202.71c-16.719 37.617-54.335 62.694-96.131 68.963l-140.016 20.898C48.765 303.021 6.969 355.265 4.879 409.6c18.808-102.4 229.878-22.988 326.008-14.629 98.22 10.45 125.388-77.322 125.388-77.322s20.898-104.49 45.976-236.147c18.808-106.58 89.86-60.604 114.938-41.796-58.514-60.604-163.004-48.065-204.8 33.437",
    fill: "#FFDE73",
    "p-id": 17851
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M590.022 798.302c-77.322-52.245-146.286 0-146.286 0s-75.232 66.874-163.004 150.465c-89.86 83.592-123.298-35.526-123.298-35.526 18.809 75.232 106.58 121.208 181.813 79.412l127.477-64.784c37.616-18.808 79.412-18.808 117.029 0l127.477 66.874c58.515 31.347 123.298 12.539 158.825-33.437 2.09-8.36 4.18-14.628 8.359-20.898-71.053 68.963-208.98-89.861-288.392-142.106",
    fill: "#FEC54A",
    "p-id": 17852
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477.173 87.771c16.719 4.18 27.167 18.809 22.988 37.617l-29.257 131.657c-4.18 16.718-18.808 27.167-37.617 22.988-16.718-4.18-27.167-18.809-22.987-37.617l29.257-133.747c4.18-16.718 20.898-25.077 37.616-20.898",
    fill: "#FFF2CA",
    "p-id": 17853
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dca2ccca.svg";
export { ForwardRef as ReactComponent };